import $ from "jquery";



const _tagFilter   = $('.filter-tag__select');
const _sortBy     = $('.filter-sort__select');

const onFilterChange = function(e) {
   location = $(this).val();
 }

 const onSortChange = function(e) {
   Shopify.queryParams = {};
   if (location.search.length) {
     for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
       aKeyValue = aCouples[i].split('=');
       if (aKeyValue.length > 1) {
         Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
       }
     }
   }
   Shopify.queryParams.sort_by = $(this).val();
   location.search = $.param(Shopify.queryParams);
 }

 const setSortSelect = function() {
  Shopify.queryParams = {};
  if (location.search.length) {
    for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
      aKeyValue = aCouples[i].split('=');
      if (aKeyValue.length > 1) {
        Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
      }
    }
  }
  console.log("_sortBy", Shopify.queryParams.sort_by);
  if (Shopify.queryParams.sort_by && Shopify.queryParams.sort_by.length>0) {
    _sortBy.val(Shopify.queryParams.sort_by);
  }
 }


export const initFilters= function() {
   _tagFilter.on('change',onFilterChange);
   _sortBy.on('change',onSortChange);
   setSortSelect();
};